/** Partner portal permission keys from GET /permission/get/:role_id (partner matrix). */
export const PARTNER_PORTAL_PERMISSION_KEYS = {
  PARTNER_PROGRAM_MANAGEMENT: "partner_partner_program_management",
  /** Roles UI label: "Access Projects" */
  ACCESS_PROJECTS: "access_projects",
  PARTNER_PROJECT_LIST: "partner_project_list",
  TIMELINE_MANAGEMENT: "timeline_management",
  VALIDATION_SUBMISSION: "validation_submission",
  VALIDATION_APPROVAL: "validation_approval",
  /** Roles UI label: "Notes History" on the integration timeline. */
  NOTES_HISTORY: "notes_history",
  /** Roles UI label: "View Service Catalog" */
  VIEW_SERVICE_CATALOG: "view_service_catalog",
  CART_CHECKOUT: "cart_checkout",
  PARTNER_ORDER_MANAGEMENT: "partner_order_management",
  PARTNER_PORTAL_DASHBOARD: "partner_portal_dashboard",
} as const;

/** OR-check for projects routes / nav (DB may use either key). */
export const PARTNER_PROJECT_ACCESS_KEYS = [
  PARTNER_PORTAL_PERMISSION_KEYS.ACCESS_PROJECTS,
  PARTNER_PORTAL_PERMISSION_KEYS.PARTNER_PROJECT_LIST,
] as const;

export type PartnerPortalPermissionKey =
  (typeof PARTNER_PORTAL_PERMISSION_KEYS)[keyof typeof PARTNER_PORTAL_PERMISSION_KEYS];
